import { Item__Talhoes } from "../../../../../../../../../services/monitoramento/resumo/get";

export function obterCoordenadasTalhao(list_talhoes: Item__Talhoes[], cod_talhao: number) {
    let talhao = (list_talhoes ?? []).find(item=> item?.cod === cod_talhao);
    return talhao?.kml?.coordenadas ?? []
}